export var config = {
  test: {
    authGateUrl: 'https://auth-gate.test.cheggnet.com/auth-gate/graphql',
    jerichoUrl: 'https://trunk.live.test.cheggnet.com',
    mfaUrl: 'https://mfa.test.identity.chegg.services/graphql',
    newRelic: {
      key: 'NRII-NKhYYYt2U1KUxYFcGdb4NKCia61dtujg',
      id: '501278'
    }
  },
  prod: {
    authGateUrl: 'https://gateway.chegg.com/auth-gate/',
    jerichoUrl: 'https://www.chegg.com',
    mfaUrl: 'https://mfa.prod.identity.chegg.services/graphql',
    newRelic: {
      key: 'NRII-Mi0ZOVEe_ofN3PNkKFbYnXl2rhtskKKD',
      id: '501356'
    }
  }
};
export var Environment = /*#__PURE__*/function (Environment) {
  Environment["test"] = "test";
  Environment["prod"] = "prod";
  return Environment;
}({});
var oneAuthEnv = Environment.test;
var cookieDomainUrl;
var clientId;
var resetPasswordRedirect = '';
var authGateUrl;
var useCheggMfa;
export function setClientId(id) {
  clientId = id;
}
export function getClientId() {
  return clientId;
}
export function getCookieDomain() {
  return cookieDomainUrl;
}
export function setCookieDomain(domain) {
  cookieDomainUrl = domain;
}
export function setEnv(newEnv) {
  oneAuthEnv = newEnv;
}
export function getEnv() {
  return oneAuthEnv;
}
export function setResetPasswordRedirect(url) {
  resetPasswordRedirect = url;
}
export function getResetPasswordRedirect() {
  return resetPasswordRedirect;
}
export function getAuthGateUrl() {
  if (authGateUrl) {
    return authGateUrl;
  }
  return config[oneAuthEnv].authGateUrl;
}
export function getMfaUrl() {
  return config[oneAuthEnv].mfaUrl;
}
export function setAuthGateUrl(url) {
  authGateUrl = url;
}
export function isAltAuthgateUrl() {
  return !!authGateUrl;
}
export function setUseCheggMfaToken(flag) {
  useCheggMfa = !!flag;
}
export function shouldUseCheggMfaToken() {
  return useCheggMfa;
}